// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import Checkbox from 'material-ui/Checkbox';

import TitledCard from 'common/components/cards/TitledCard';
import Other from './Other';
import type { StreamConfigurationFormSection, StreamingTechnologiesData } from '../../domain/StreamConfiguration';

type Props = {
  onChange: (value: StreamConfigurationFormSection) => void,
  data: StreamingTechnologiesData,
  t: any,
}

function StreamingTechnologies(props: Props) {
  return (
    <TitledCard style={{ width: '100%' }} title={props.t('streamingTechnologies')}>
      <div className="row">
        <div className="col-xs-3">
          <Checkbox
            label={props.t('none')}
            name="none"
            onCheck={(e, v) => props.onChange({ ...props.data, none: v })}
            checked={props.data.none}
          />
        </div>
        <div className="col-xs-3">
          <Checkbox
            label={'ICECAST'}
            name="icecast"
            onCheck={(e, v) => props.onChange({ ...props.data, icecast: v })}
            checked={props.data.icecast}
          />
        </div>
        <div className="col-xs-6">
          <Checkbox
            label={'SHOUTCAST CAST'}
            name="shoutcast_cast"
            onCheck={(e, v) => props.onChange({ ...props.data, shoutcast_cast: v })}
            checked={props.data.shoutcast_cast}
          />
        </div>
      </div>
      <Other onChange={(k, v) => props.onChange({ ...props.data, [k]: v })} data={props.data} />
    </TitledCard>
  );
}

export default translate('radioConfiguration')(StreamingTechnologies);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/streamConfigurationForm/StreamingTechnologies.js